import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.4 6.843 5.3-5.18a.93.93 0 0 0 0-1.37.98.98 0 0 0-1.4 0L7 5.474 1.7.294a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l5.3 5.181-5.3 5.181a.93.93 0 0 0 0 1.37c.2.194.4.292.7.292s.5-.098.7-.293L7 8.213l5.3 5.18c.2.195.5.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.369z"
    }, null, -1)
  ]))]))
}
export default { render: render }